export default {
  login: '登入',
  logout: '登出',
  username: '使用者名稱',
  password: '密碼',
  rememberMe: '記住我',
  forgotPassword: '忘記密碼？',
  loginSuccess: '登入成功',
  loginFailed: '登入失敗',
  unauthorized: '未授權，請重新登入',
  forbidden: '權限不足',
};
